<template>
  <Card class="flex-none h-auto w-[400px]">
    <template #header>
      <div class="flex flex-row px-5 py-3 justify-center rounded-t-xl bg-primary-200 dark:bg-primary-700">
        <h1 class="font-bold text-xl">Project Contacts</h1>
      </div>
    </template>
    <template #content>
      <div class="flex flex-col gap-8 px-10 my-auto h-full justify-center" pt:body:class="h-full" pt:content:class="h-full">
        <p v-if="contacts.length === 0" class="font-bold my-auto mx-auto">- No Current Contacts -</p>
        <ContactInformation
          v-else
          v-for="contact in contacts"
          :project-entity="contact"
          :can-edit="canEdit"
          @entity-selected="display"
          @project-entity-removed="contactRemoved"
        ></ContactInformation>
        <Button v-if="canEdit" icon="pi pi-plus-circle" label="Add Contact..." text class="w-fit p-0! mx-auto" @click="addContact"></Button>
      </div>
    </template>
  </Card>

  <TSDialog label="Add Project Contact" v-model:visible="displayEntity" icon="info-circle" size="w-[1000px]!">
    <template #content>
      <AddProjectEntity :contact="addingContact" :entity-to-display="entityToDisplay" @contact-selected="contactAdded"></AddProjectEntity>
    </template>
  </TSDialog>
</template>

<script setup lang="ts">
import { createProjectEntity, type ProjectEntity } from "@/types/ProjectEntity";
import { ref } from "vue";
import type { Entity } from "@/types/Entity";
import type { Project } from "@/types/Projects";
import { entityAlreadyExistsInProject } from "@/services/Utility";

const contacts = defineModel<ProjectEntity[]>("contacts", { required: true });

const addingContact = ref(false);

const displayEntity = ref(false);

const entityToDisplay = ref<Entity>();

interface Props {
  canEdit: boolean;
  sourceOfFunds: ProjectEntity[];
  project: Project;
}
const props = defineProps<Props>();

const display = (entity: Entity): void => {
  entityToDisplay.value = entity;
  displayEntity.value = true;
};

const addContact = (): void => {
  entityToDisplay.value = undefined;
  addingContact.value = true;
  displayEntity.value = true;
};

const contactAdded = (entity: Entity, contactRole: string): void => {
  if (entityAlreadyExistsInProject(props.project.projectInfo, props.sourceOfFunds, contacts.value, entity)) return;

  // const role = getProjectRoleFromDisplayText(contactRole);
  // if (role == null) {
  //   error("Error Occurred", "Invalid contact type selected");
  //   return;
  // }

  const projectEntity = createProjectEntity(
    contactRole.toUpperCase(),
    entity,
    6 + props.sourceOfFunds.length - 2 + contacts.value.length,
    props.project.projectDrawInfo.drawNumber,
    props.project.projectInfo.projectId
  );

  axios
    .post("/project-entity/contact/add", projectEntity)
    .then((response) => {
      handleApiResponse(
        response,
        (data: any) => {
          success("Contact Added", "");
          projectEntity.projectEntityId = data;
          contacts.value.push(projectEntity);
          displayEntity.value = false;
          addingContact.value = false;
        },
        (errors: ApiError[]) => {
          error("Error Occurred", errors[0].message);
        }
      );
    })
    .catch((e) => errorApi(e));
};

const contactRemoved = (projectEntity: ProjectEntity): void => {
  axios
    .post(`/project-entity/contact/delete/${projectEntity.projectEntityId}`)
    .then((response) => {
      handleApiResponse(
        response,
        (data: any) => {
          success("Contact Removed", "");
          contacts.value.splice(
            contacts.value.findIndex((pe) => pe.projectEntityId === projectEntity.projectEntityId),
            1
          );
        },
        (errors: ApiError[]) => {
          error("Error Occurred", errors[0].message);
        }
      );
    })
    .catch((e) => errorApi(e));
};
</script>
